export default __webpack_public_path__ + "static/media/backend.b3657c70.jpg";